import type { ToolMeta } from './registry';

export const executeClientActionsMeta = {
  description:
    "Run actions in the couple's Bridebook app — guest add/remove/RSVP, wedding events and per-event guest invites, supplier notes, checklist ticks, a currency change they ask for, navigation through the app and sending enquiries. Profile facts are not among them: the app records those from the conversation.",
  examples: [
    'Add Anna and Jan to our guest list',
    'Mark "book the photographer" as done',
    'Add a rehearsal dinner the evening before and invite the wedding party',
    'Send an enquiry to the first two venues',
    'Show me the guest list for the after party',
  ],
  value: 'changes made in their app for them, when they ask',
} as const satisfies ToolMeta;
